// Systems.tsx
import React, { } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import AccordionPanel from "../components/system/AccordionPanel";
import ConfigDetails from "../components/system/ConfigDetails";
import SystemDetails from "../components/system/SystemDetails";
import SystemSettingsForm from "../components/system/forms/SystemSettingsForm";
import { SystemsProvider, useSystemsContext } from "../context/SystemsContext";
import SystemActionButtons from "../components/system/SystemActionButtons";

// This new component decides which main view to show
const MainContentPanel: React.FC = () => {
  const { isLoadingSystem, selectedSection, selectedConfig: expandedConfigId, configs } = useSystemsContext();
  const selectedConfig = configs.find((c: any) => c.clientProcess?.name === expandedConfigId);
  const configSectionData = selectedConfig?.[selectedSection || ""];

  if (isLoadingSystem) {
    return (
      <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress size={60} />
      </Box>
    );
  }
  if (selectedSection === "createSystem") {
    return <SystemSettingsForm />;
  }
  if (selectedSection === "systemInfo") {
    return <SystemDetails />;
  }
  if (configSectionData) {
    return <ConfigDetails />;
  }
  return <Typography variant="body1" sx={{ mt: 4 }}>Select a section to view details</Typography>;
};

const Systems: React.FC = () => {
  return (
    <SystemsProvider>
      <Box sx={{ display: 'flex', height: '100%', minHeight: 0, overflow: 'hidden' }}>
        {/* AccordionPanel will now use the context internally, no props needed! */}
        <AccordionPanel />

        {/* The right panel is now clean */}
        <Box sx={{ flex: 1, p: 3, overflow: "auto" }}>
          <MainContentPanel />
          <SystemActionButtons />
        </Box>
      </Box>

    </SystemsProvider>
  );
};



export default Systems;
